'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CoverStartDate;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _splitField = require('../components/split-field');
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
CoverStartDate.propTypes = {
  helpText: _propTypes.string,
  onBlur: _propTypes.func
};
CoverStartDate.defaultProps = {
  helpText: null,
  onBlur: undefined
};
function CoverStartDate(props) {
  return _react2.default.createElement(_splitField.Date, {
    name: 'coverStartDate',
    helpText: props.helpText,
    label: 'When do you want your cover to start?',
    onBlur: props.onBlur
  });
}